import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

(function () {
  function initializeSwiper(selector, imageClass, updateClass = false) {
    let galleries = document.querySelectorAll(selector);
    galleries.forEach(function(gallery) {
        gallery.classList.add("swiper");
        let swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");
        let wpBlockImages = gallery.querySelectorAll(imageClass);
        wpBlockImages.forEach(function(wpBlockImage) {
            wpBlockImage.classList.add("swiper-slide");
            swiperWrapper.appendChild(wpBlockImage);
        });
        gallery.appendChild(swiperWrapper);
        let swiperButtonPrev = document.createElement("div");
        swiperButtonPrev.classList.add("swiper-button-prev");
        gallery.appendChild(swiperButtonPrev);
        let swiperButtonNext = document.createElement("div");
        swiperButtonNext.classList.add("swiper-button-next");
        gallery.appendChild(swiperButtonNext);
        let swiperPagination = document.createElement("div");
        swiperPagination.classList.add("swiper-pagination");
        gallery.appendChild(swiperPagination);

        // Swiperの初期化
        let swiperInstance = new Swiper(selector, {
          calculateHeight: true,
          spaceBetween: 19,
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
          },
          pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
          }
        });

        // .swiper-galleryの場合にクラスを追加
        if (updateClass) {
          swiperInstance.on('slideChange', function () {
            // 現在のスライドインデックスを取得
            let currentIndex = swiperInstance.realIndex + 1; // インデックスを1から始まるように調整

            // 既存の"slide-x"クラスを削除
            gallery.classList.forEach(function(cls) {
              if (cls.startsWith('slide-')) {
                gallery.classList.remove(cls);
              }
            });

            // 新しいクラスを追加
            gallery.classList.add('slide-' + currentIndex);
          });

          // 初期スライドのクラスを設定
          gallery.classList.add('slide-' + (swiperInstance.realIndex + 1));
        }
    });
  }

  // Initialize Swiper for .swiper-gallery with class update
  initializeSwiper('.swiper-gallery', '.wp-block-image', true);

  // Initialize Swiper for .swiper-example without class update
  initializeSwiper('.swiper-example', '.wp-block-columns');

})();
